module.exports = __webpack_public_path__ + "img/people-13.d052adf6.png";